export const DB_URL_FLAG=true

export const rediectLink = link => {
    return link.startsWith("http://") || link.startsWith("https://") ?
    link : `http://${link}`
  }